"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createSvgIcon = _interopRequireDefault(require("Functions/createSvgIcon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
let path = /*#__PURE__*/_react.default.createElement("g", {
  id: "home-office",
  transform: "translate(0 -36)"
}, /*#__PURE__*/_react.default.createElement("circle", {
  id: "Ellipse_116",
  "data-name": "Ellipse 116",
  cx: "1.5",
  cy: "1.5",
  r: "1.5",
  transform: "translate(36.889 89.593)",
  fill: "#fff"
}), /*#__PURE__*/_react.default.createElement("path", {
  id: "Trac\xE9_2182",
  "data-name": "Trac\xE9 2182",
  d: "M181.529,55.523V37.5a1.5,1.5,0,0,0-1.5-1.5H166.512A10.524,10.524,0,0,0,156,46.512V47.55a1.5,1.5,0,0,0,1.981,1.423,18.246,18.246,0,0,1,2.524-.653v7.2a10.512,10.512,0,0,0,21.024,0Zm-22.465-9.972A7.523,7.523,0,0,1,166.512,39h11.863a7.521,7.521,0,0,1-7.358,6.008h-7.145A21.71,21.71,0,0,0,159.065,45.551Zm11.953,17.48a7.517,7.517,0,0,1-7.509-7.509v-7.5c.121,0,7.509,0,7.509,0a10.479,10.479,0,0,0,7.509-3.165V55.523A7.517,7.517,0,0,1,171.017,63.031Z",
  transform: "translate(-132.573)",
  fill: "#fff"
}), /*#__PURE__*/_react.default.createElement("path", {
  id: "Trac\xE9_2183",
  "data-name": "Trac\xE9 2183",
  d: "M68.629,260.028a8.249,8.249,0,0,0-2.7.455l1.9-7.6a1.5,1.5,0,0,0-1.457-1.866H60.219A15.034,15.034,0,0,0,45.2,236H31.687a15.034,15.034,0,0,0-15.017,15.017H10.512a1.5,1.5,0,0,0-1.457,1.866l1.9,7.6A8.253,8.253,0,0,0,0,268.287v2.253a1.5,1.5,0,0,0,1.5,1.5H31.687a1.5,1.5,0,0,0,0-3H16.19l-3.754-15.017H64.453L60.7,269.038H45.2a1.5,1.5,0,0,0,0,3H75.387a1.5,1.5,0,0,0,1.5-1.5v-2.253A8.269,8.269,0,0,0,68.629,260.028Zm-55.535,9.01H3v-.751a5.254,5.254,0,0,1,8.975-3.712ZM33.188,239H43.7v.751a5.256,5.256,0,0,1-10.512,0ZM19.673,251.017A12.029,12.029,0,0,1,30.185,239.1v.654a8.26,8.26,0,0,0,16.519,0V239.1a12.029,12.029,0,0,1,10.512,11.917Zm54.213,18.021H63.795l1.116-4.463a5.254,5.254,0,0,1,8.975,3.712Z",
  transform: "translate(0 -169.965)",
  fill: "#fff"
}), /*#__PURE__*/_react.default.createElement("ellipse", {
  id: "Ellipse_117",
  "data-name": "Ellipse 117",
  cx: "1.5",
  cy: "2",
  rx: "1.5",
  ry: "2",
  transform: "translate(36.889 98.593)",
  fill: "#fff"
}));
let viewBox = '0 0 76.889 66.593';
var _default = exports.default = (0, _createSvgIcon.default)(path, 'EntrepreneurIcon', viewBox);
